// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"_8317","item":"_14010","two":"_19538"};